module.exports = __webpack_public_path__ + "img/calendario-1-2grade.1f5baf14.png";